(() => {
  const form = document.getElementById('quote-form');
  if (!form || form.dataset.hcContactReady) return;
  form.dataset.hcContactReady = 'true';
  const countryFields = {
    'United States - US': 'state',
    'Canada - CA': 'province',
    'Japan - JP': 'prefecture',
    'United Kingdom - UK': 'county'
  };
  const updateCountry = () => {
    const selected = form.querySelector('#country')?.value;
    form.querySelectorAll('[data-dependant-of="country"]').forEach(group => {
      const active = group.id === countryFields[selected] + '-field-group';
      group.classList.toggle('is-hidden', !active);
      group.querySelectorAll('input,select').forEach(input => { input.disabled = !active; });
    });
  };
  const updateReferral = () => {
    const group = form.querySelector('[data-condition="Event/Other"]');
    if (!group) return;
    const active = form.querySelector('#lead-source')?.value === 'Event/Other';
    group.classList.toggle('is-hidden', !active);
    group.querySelectorAll('input').forEach(input => { input.disabled = !active; });
  };
  form.querySelector('#country')?.addEventListener('change', updateCountry);
  form.querySelector('#lead-source')?.addEventListener('change', updateReferral);
  updateCountry();
  updateReferral();
})();
